import React from 'react';

const D3Logo = (props) => (
    <svg viewBox="-10 -10 116 111" {...props}>
        <defs>
            <path
                id="prefix__a"
                d="M0 0h7.8a45.5 45.5 0 110 91H0V71h7.8a25.5 25.5 0 100-51H0zm36.3 0h32a27.8 27.8 0 0121.3 45.5A27.8 27.8 0 0168.3 91h-32A53.7 53.7 0 0055 71h13.3a7.8 7.8 0 100-15.5h-7.8a53.7 53.7 0 000-20h7.8a7.8 7.8 0 100-15.5H55A53.7 53.7 0 0036.3 0z"
            />
        </defs>
        <use
            fill="none"
            stroke="#000"
            strokeWidth={20}
            xlinkHref="#prefix__a"
        />
        <use fill="#fff" xlinkHref="#prefix__a" />
    </svg>
);

export default D3Logo;
